import * as moment from 'moment';
import { Uptime } from '@ionic-native/uptime/ngx';
import { StorageService } from './storageservice';
import { Platform } from '@ionic/angular';
import { CacheTime } from './entities/cacheTime.class';
import { DateTimeFormat, DateTimeWebFormat, MomentDefaultFormat } from './entities/constantsExport.class';
import { Injectable } from '@angular/core';
import { MomentFormats } from 'src/shared/entities/momentFormats.class';

@Injectable()
export class UptimeService {
    uptimeTolerance: number = 0;
    uptimeVal: string;
    additionalDebug: string;
    timePointsDebug: string;
    lastKnownUptime: string = "";

    offlineUptimeWarning: boolean = false;
    lastKnownInterval: any;
    offlineTimeChecked: boolean = false;
    public readonly cacheVisitKey = "VisitData";
    public readonly cacheTimesKey = "CacheTimes";
    public readonly cacheAssignedPatientsKey = "AssignedPatients";
    constructor(
        private plt: Platform,
        private uptime: Uptime,
        private storage: StorageService
    ) {

    }

    isCordova(){
        return this.plt.is('cordova');
    }

    syncAndStoreOnlineTime(commonTime: string){
        return this.uptime.getUptime(true).then(uptime => {
            localStorage.setItem("storedUptime", uptime);
            localStorage.setItem("restartUptime", "0");
            localStorage.setItem("restartTime", "");
            localStorage.setItem("restartAdd", "0");

            //need to also update lastKnownUptime. Otherwise it might fall behind storedTime
            this.setLastKnownUptime(uptime);

            var timePoint = new CacheTime(-1, false, moment(commonTime, DateTimeWebFormat).format(DateTimeFormat), 0, parseInt(uptime), true, 0, false, "", 0);
            this.addToCacheTimeArray(timePoint);
        })
        .catch(error => {console.log(error);});
    }

    addToCacheTimeArray(newCacheTime: CacheTime){
        this.storage.get(this.cacheTimesKey).then(data => {
            var cacheTimesArray = new Array<CacheTime>();
            if(data != null){
                cacheTimesArray = data;
            }

            if(newCacheTime.synced == true && newCacheTime.serviceOrderId == -1){
                cacheTimesArray = this.recalculateCacheTimeArray(cacheTimesArray, newCacheTime);
            }

            if(newCacheTime.serviceOrderId == -1){
                if(cacheTimesArray.length > 0){
                    if(cacheTimesArray[cacheTimesArray.length-1].serviceOrderId == -1 && cacheTimesArray[cacheTimesArray.length-1].synced == true && newCacheTime.synced == true){
                        cacheTimesArray.splice(cacheTimesArray.length-1, 1, newCacheTime);
                    }else{
                        cacheTimesArray.push(newCacheTime);
                    }
                }else{
                    cacheTimesArray.push(newCacheTime);
                }
            }else{
                if(newCacheTime.serviceOrderId != 0){
                    var index = cacheTimesArray.findIndex(x => x.serviceOrderId == newCacheTime.serviceOrderId && x.isArrival == newCacheTime.isArrival);
                    if(index != -1){
                        cacheTimesArray.splice(index, 1);
                    }
                    cacheTimesArray.push(newCacheTime);
                }else{
                    var index = cacheTimesArray.findIndex(x => x.patientServiceOrderId == newCacheTime.patientServiceOrderId && x.isArrival == newCacheTime.isArrival);
                    if(index != -1){
                        cacheTimesArray.splice(index, 1);
                    }
                    cacheTimesArray.push(newCacheTime);
                }
            }

            cacheTimesArray = this.recalculateCacheTimeArray(cacheTimesArray, newCacheTime, true);
            
            this.viewTimePointArray(cacheTimesArray);
            this.timePointsDebug += "\nnewCacheTime: "+newCacheTime.serviceOrderId+" "+newCacheTime.isArrival+" "
            +moment(newCacheTime.time, MomentFormats.momentFormats).format(DateTimeFormat)+" "+newCacheTime.timezone+" "+newCacheTime.uptime+" "
            +newCacheTime.synced+" "+newCacheTime.restart+" "+newCacheTime.negative+" "+newCacheTime.time+" \n";

            this.storage.set(this.cacheTimesKey, cacheTimesArray);
        });
    }
    
    recalculateCacheTimeArray(cacheTimesArray: CacheTime[], newCacheTime: CacheTime, onlySync = false){
        if(!onlySync){
            var p = 0;
            for(let i=cacheTimesArray.length-1; i>=0; i--){
                if(cacheTimesArray[i].synced == true || cacheTimesArray[i].serviceOrderId == -1){
                    p = i;
                    break;
                }else if(cacheTimesArray[i].oldTime == ""){
                    let time = moment(newCacheTime.time, DateTimeFormat).subtract(newCacheTime.uptime - cacheTimesArray[i].uptime).format(DateTimeFormat);
                    cacheTimesArray[i].oldTime = moment(cacheTimesArray[i].time).format(DateTimeFormat);
                    cacheTimesArray[i].time = (moment(cacheTimesArray[i].time).diff(time, 'minutes') < this.uptimeTolerance) ? cacheTimesArray[i].time : time;
                    cacheTimesArray[i].restart = 0;
                    cacheTimesArray[i].negative = false;
                }
            }
            for(let i=p-1; i>=0; i--){
                if(cacheTimesArray[i].oldTime == "" && cacheTimesArray[i].synced == false && cacheTimesArray[i].serviceOrderId != -1){
                    cacheTimesArray[i].negative = cacheTimesArray[i].restart != 0 && (cacheTimesArray[i].negative || (moment(cacheTimesArray[i].time).isAfter(newCacheTime.time)
                        && Math.abs(moment(cacheTimesArray[i].time).diff(newCacheTime.time)) > this.uptimeTolerance * 60000));
                }
            }
        }

        var newCacheTimesArray = new Array<CacheTime>();
        for(let i=0; i<cacheTimesArray.length-1; i++){
            if(!(cacheTimesArray[i].synced == true && cacheTimesArray[i].serviceOrderId == -1 &&
            cacheTimesArray[i+1].synced == true && cacheTimesArray[i+1].serviceOrderId == -1)){
                newCacheTimesArray.push(cacheTimesArray[i]);
            }
        }
        if(cacheTimesArray.length-1 >= 0) newCacheTimesArray.push(cacheTimesArray[cacheTimesArray.length-1]);
        return newCacheTimesArray;
    }
    
    removeFromCacheTimeArray(){
        this.storage.get(this.cacheTimesKey).then(data => {
            var cacheTimesArray = new Array<CacheTime>();
            if(data != null) cacheTimesArray = data;
            cacheTimesArray = cacheTimesArray.slice(-1);
            
            this.storage.set(this.cacheTimesKey, cacheTimesArray);
            
            this.viewTimePointArray(cacheTimesArray);
            localStorage.setItem("patientServiceOrderId", "0");
        });
    }
    
    viewTimePointArray(cacheTimesArray){
        this.timePointsDebug = "";
        for(let i=0; i<cacheTimesArray.length; i++){
            this.timePointsDebug += i+" "+cacheTimesArray[i].serviceOrderId+" "+cacheTimesArray[i].isArrival+" "
            +moment(cacheTimesArray[i].time, DateTimeFormat).format(DateTimeFormat)+" "+cacheTimesArray[i].timezone+" "+cacheTimesArray[i].uptime+" "
            +cacheTimesArray[i].synced+" "+cacheTimesArray[i].restart+" "+cacheTimesArray[i].negative+" "+cacheTimesArray[i].time
            +" pID: "+cacheTimesArray[i].patientServiceOrderId+" \n";
        }
    }

    setLastKnownUptime(uptime: string){
        localStorage.setItem("lastKnownUptime", uptime);
        let restartUptime3 = localStorage.getItem("restartUptime") != '' ? parseInt(localStorage.getItem("restartUptime")) : 0;
        let uptimeDiff = parseInt(uptime) + restartUptime3 - parseInt(localStorage.getItem("storedUptime"));// + parseInt(localStorage.getItem("commonDiff"));
        localStorage.setItem("lastKnownTime", (moment(localStorage.getItem("commonTime"), DateTimeFormat).add(uptimeDiff)).format(DateTimeFormat));
    }

    getOfflineTime(){
        return new Promise<any>(resolve => {
            this.uptime.getUptime(true).then(uptime => {
                this.setLastKnownUptime(uptime);
                var timeStr = localStorage.getItem("lastKnownTime");
                resolve(timeStr);
            });
        });
    }
}